module.exports = __webpack_public_path__ + "static/img/3.f27c3e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/eng/3.png
// module id = 7WjZ
// module chunks = 0